import { useStoreState, useStoreActions } from "@/store";

export const useGetUserInfo = () => {
  return useStoreState((state) => state.userModel.userInfo);
};

export const useSetUserInfo = () => {
  return useStoreActions((actions) => actions.userModel.setUserInfo);
};

export const useGetMeidouInfo = () => {
  return useStoreState((state) => state.userModel.meidouInfo);
};

export const useSetMeidouInfo = () => {
  return useStoreActions((actions) => actions.userModel.setMeidouInfo);
};

export const useGetCutoutInfo = () => {
  return useStoreState((state) => state.userModel.cutoutInfo);
};

export const useGetIsRequested = () => {
  return useStoreState((state) => state.userModel.isRequested);
};
